<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (type of extensionTypes | async; track trackBy(type)) {
      <lcs-option [value]="type" id="lcs-option-id-{{ type.extensionTypeId }}">
         {{ type.displayName }}
      </lcs-option>
      }
   </div>
</ng-template>
